import React from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import toast from "react-hot-toast";
import { FaMoneyBillWave } from "react-icons/fa";

import { UserService } from "_services";
import Emitter from "_actions/emitter";
import { getCurrency } from "components/Navbar/NavUserBox";
import i18n from "i18n";
import RequestsPage from "./RequestsPage";

const WithdrawRequests = (props) => {
  const [requests, setRequests] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [cancellingId, setCancellingId] = React.useState(null);

  const userInfo = { ...props.user, ...props.user?.RelUser };
  const currency = getCurrency(userInfo.Currency);

  const loadRequests = () => {
    setLoading(true);
    UserService.GET_MY_WITHDRAW_REQUESTS()
      .then((res) => {
        setRequests(res || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    loadRequests();
  }, []);

  React.useEffect(() => {
    Emitter.on("WITHDRAW_REQUEST_CREATED", loadRequests);
    return () => {
      Emitter.off("WITHDRAW_REQUEST_CREATED");
    };
  }, []);

  const handleCancel = (requestId) => {
    setCancellingId(requestId);
    UserService.CANCEL_WITHDRAW_REQUEST(requestId)
      .then(() => {
        setCancellingId(null);
        loadRequests();
        Emitter.emit("REFRESH_WALLET");
      })
      .catch((err) => {
        setCancellingId(null);
        const failText = err?.response?.data?.failText?.[0];
        toast.error(failText || i18n.t("WITHDRAW_REQUEST_CANCEL_ERROR"));
      });
  };

  return (
    <Translation>
      {(t) => (
        <RequestsPage
          t={t}
          icon={FaMoneyBillWave}
          title={t("NAV_TITLE_WITHDRAW_REQUESTS")}
          subtitle={t("BALANCE_MODAL_WITHDRAW_SUBTITLE")}
          requests={requests}
          loading={loading}
          currency={currency}
          cancellingId={cancellingId}
          onCancel={handleCancel}
          onNewRequest={() => Emitter.emit("BALANCE_MODAL", "withdraw")}
          newButtonLabel={t("WITHDRAW_REQUEST_NEW_BUTTON")}
          noDataLabel={t("WITHDRAW_REQUEST_NO_DATA")}
          cancelButtonLabel={t("WITHDRAW_REQUEST_CANCEL_BUTTON")}
          cancelConfirmLabel={t("WITHDRAW_REQUEST_CANCEL_CONFIRM")}
          statusPrefix="BONUS_REQUEST_STATUS_"
          getAmount={(item) => item.Amount}
          extraColumns={[]}
        />
      )}
    </Translation>
  );
};

const mapStateToProps = (state) => {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user,
  };
};

export default connect(mapStateToProps)(WithdrawRequests);
